import React, { FC, useState, useEffect } from "react";

// ========== Utils ========== //
// ========== Hooks ========== //

export const PaymentPrepaidPage: FC = () => {

    return (
        <div className="flex flex-1 flex-col overflow-hidden h-full">
            <p>PaymentPrepaidPage</p>
        </div>
    )
}